import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { UiComponentsModule } from '@fcom/ui-components';

import { SubviewComponent } from './subview.component';

@NgModule({
  imports: [CommonModule, ComponentsModule, PipesModule, UiTranslateModule, UiComponentsModule],
  declarations: [SubviewComponent],
  exports: [SubviewComponent],
})
export class SubViewModule {}
